import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const delete_user = (id) => {
  return api.post(`${ApiEndpointConstants.DELETEUSER}`, {}, { params: { id } });
};
